import { render, staticRenderFns } from "./Typography8.vue?vue&type=template&id=908ee39c&scoped=true"
import script from "./Typography8.vue?vue&type=script&lang=js"
export * from "./Typography8.vue?vue&type=script&lang=js"
import style0 from "./Typography8.vue?vue&type=style&index=0&id=908ee39c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "908ee39c",
  null
  
)

export default component.exports